/** Paths cards copy in Arabic. Mirrors `../../en/home/paths.js` key for key. */
import { ACTIONS } from '../site'

export const PATHS = [
  {
    icon: 'calendar',
    title: 'جرّبه مجانًا',
    stat: '14 يومًا',
    text: 'أنشئ منظمتك وجرّب كل اللوحات مجانًا لمدة 14 يومًا.',
    link: ACTIONS.start,
  },
  {
    icon: 'users',
    title: 'تطبيق واحد لكل الأدوار',
    stat: '4 لوحات',
    text: 'لفريقك والاستقبال والموارد البشرية والمسؤولين لوحة لكل منهم، وكلها على جدول واحد.',
    link: { label: 'شاهد اللوحات', href: '/#panels' },
  },
  {
    icon: 'message',
    title: 'شاهده مع قاعاتك',
    stat: 'عرض مجاني',
    text: 'سنأخذك في جولة على MeetNPlan باستخدام قاعاتك وفريقك.',
    link: ACTIONS.demo,
    dark: true,
  },
]
